import { formatCurrency, formatDate } from './index';
export const columns = [
  {
    key: 'transaction_id',
    label: 'Reference',
    width: '150px',
  },
  {
    key: 'user',
    label: 'User',
    format: (item) => item.user?.name || 'N/A',
  },
  {
    key: 'amount',
    label: 'Amount',
    format: (item) => formatCurrency(item.amount),
  },
  {
    key: 'status',
    label: 'Status',
  },
  {
    key: 'created_at',
    label: 'Date',
    format: (item) => formatDate(item.created_at),
  },
]

export function getPaymentStatusClass(status) {
  switch (status) {
    case 'completed':
      return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
    case 'pending':
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200'
    case 'failed':
      return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200'
  }
}

export const getPaymentStatus = (status) => {
  const paymentStatusMap = {
    pending: 'Pending',
    success: 'Success',
    failed: 'Failed',
    paid: 'Paid',
    completed: 'Completed',
    unpaid: 'Unpaid',
  }
  return paymentStatusMap[status] || 'Unknown'
}
